<div class="title">
    <span>{{ 'realtime:usergroups_logOnTitle' | i18next }}</span>
        <i id="close-btn-set-logon-dialog" class="close-icon" mat-button cdkFocusInitial [mat-dialog-close]="false" (click)="closeDialog()"></i>
</div>

<div class="dialog-content">
    <p>{{ 'realtime:usergroups_logOnText' | i18next }} <span class="user-name">{{ userName }}</span></p>

    <table class="logon-form-table">
        <tbody>
            <tr>
                <td class="label-cell">
                    {{ 'realtime:usergroups_labelPhoneNumber' | i18next }}
                </td>
                <td class="input-cell">
                    <input
                        id="phone-number-input-set-logon-dialog"
                        [(ngModel)]="phoneNumber"
                        (ngModelChange)="onPhoneNumberChange()"
                        class="dialog-input"
                        [class.invalid]="!phoneNumberValid && phoneNumber"
                        placeholder="Enter phone number"
                        required />
                </td>
            </tr>
            <tr>
                <td class="label-cell">
                    {{ 'realtime:usergroups_labelProfile' | i18next }}
                </td>
                <td class="select-loading-wrapper">
                  <app-basic-dropdown
                        id="profile-dropdown-set-logon-dialog"
                        [(model)]="selectedProfileId"
                        [items]="profiles"
                        bindLabel="name"
                        bindValue="id"
                        [clearable]="false"
                        [searchable]="false"
                        width="380px"
                        appendTo="#ddl-panel-wrapper"
                        [showIcon]="false"
                        placeholder="Select profile">
                  </app-basic-dropdown>
                    <span *ngIf="isLoading" class="loading-spinner"></span>
                </td>
            </tr>
        </tbody>
    </table>

    <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
    </div>
</div>
<mat-dialog-actions>
    <app-basic-button id="close-btn-set-logon-dialog" type="secondary" size="large" (click)="closeDialog()"> {{ 'translation:Close' | i18next }}</app-basic-button>
    <app-basic-button id="confirm-btn-set-logon-dialog" type="primary" size="large" (click)="closeDialogWithResult()" >{{ 'realtime:usergroups_logOnConfirm' | i18next }}</app-basic-button>
</mat-dialog-actions>
